import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

import { Gender } from '@/types/user';

type GenderSelectProps = Omit<
  React.ComponentProps<typeof Select>,
  'value' | 'onValueChange'
> & {
  value: Gender;
  onValueChange: (value: Gender) => void;
};

export const GenderSelect = React.forwardRef<
  React.ElementRef<typeof Select>,
  GenderSelectProps
>(({ value, onValueChange, ...rest }, ref) => {
  return (
    <Select
      {...rest}
      onValueChange={(value) => onValueChange(value as Gender)}
      value={value as string}
    >
      <SelectTrigger ref={ref}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {GENDER_VALUES.map((gender) => (
          <SelectItem key={gender} value={gender} className="capitalize">
            {GENDER_LABELS[gender]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

export const GENDER_VALUES: Gender[] = ['female', 'male'];
export const GENDER_LABELS: {
  [key in Gender]: string;
} = {
  female: 'Femme',
  male: 'Homme',
};
